const Footer = () => {
  return (
    <footer className="bg-[#96653a] text-white py-6 mt-0">
  <div className="container mx-auto flex flex-col sm:flex-row justify-between px-4">
    <p className="text-left">&copy; {new Date().getFullYear()} AbhaCare. All rights reserved.</p>
    <p className="text-left text-semibold sm:text-right">By M2 Software Solutions</p>
  </div>
</footer>
  );
};

export default Footer;
